/*
 * Менеджер данных
 */
export default {
  // хранилище данных
  data: {},

  // типы добавления данных
  types: {
    add: 'add',
    replace: 'replace',
  },

  // метод добавления данных
  addData(name, value, mode = this.types.add) {
    let currentValue;

    if (mode === this.types.replace) {
      currentValue = value;
    } else if (typeof value === typeof {}) {
      // { 1: 1, 2: 1 }
      currentValue = {
        ...this.data[name],
        ...value,
      };
    } else {
      currentValue = this.data[name] ? `${this.data[name]}|${value}` : value;
    }

    this.data = {
      ...this.data,
      [name]: currentValue,
    };
  },

  getData() {
    return this.data;
  },

  eraseKeyData(key) {
    const currentData = { ...this.data };
    delete currentData[key];

    this.data = currentData;
  },

  eraseAllData() {
    this.data = {};
  },
};



// WEBPACK FOOTER //
// ./src/lib/manager/index.js